import React, { useReducer, useContext } from "react";
import axios from "axios";
import ProductContext from "./ProductContext";
import ProductReducer from "./ProductReducer";
import {
  GET_PRODUCTS,
  ADD_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PRODUCT,
  FILTER_PRODUCTS,
  CLEAR_PRODUCT_FILTER,
  SET_CURRENT_PRODUCT,
  CLEAR_CURRENT_PRODUCT,
  PRODUCT_ERROR,
  // CLEAR_PRODUCTS
} from "../types";
import AuthContext from "../auth/AuthContext";

const ProductState = (props) => {
  const initialState = {
    products: null,
    current: null,
    filtered: null,
    error: null,
  };

  const [state, dispatch] = useReducer(ProductReducer, initialState);
  const { user } = useContext(AuthContext);

  const getProducts = async () => {
    try {
      const fieldToQuery = "id,title,variants";
      const res = await axios.get(`/api/products?field=${fieldToQuery}`);

      dispatch({
        type: GET_PRODUCTS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PRODUCT_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const addProduct = async (product) => {
    const config = {
      "Content-Type": "application/json",
    };

    try {
      delete product.ProductRecordID;
      const res = await axios.post(
        "/api/products/",
        { ...product, username: user.name },
        config
      );

      dispatch({
        type: ADD_PRODUCT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PRODUCT_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const deleteProduct = async (id) => {
    try {
      const res = await axios.delete(`/api/products/${id}/${user.name}`);

      dispatch({
        type: DELETE_PRODUCT,
        payload: id,
      });
    } catch (err) {
      dispatch({
        type: PRODUCT_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const updateProduct = async (product) => {
    const config = {
      "Content-Type": "application/json",
    };

    try {
      const res = await axios.put(
        `/api/products/${product.ProductRecordID}`,
        { ...product, username: user.name },
        config
      );
      dispatch({
        type: UPDATE_PRODUCT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PRODUCT_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const filterProducts = (text) => {
    dispatch({
      type: FILTER_PRODUCTS,
      payload: text,
    });
  };

  const clearFilter = () => {
    dispatch({
      type: CLEAR_PRODUCT_FILTER,
    });
  };

  const setCurrent = (product) => {
    dispatch({
      type: SET_CURRENT_PRODUCT,
      payload: product,
    });
  };

  const clearCurrent = () => {
    dispatch({
      type: CLEAR_CURRENT_PRODUCT,
    });
  };

  // const clearProducts = () => {
  //   dispatch({
  //     type: CLEAR_PRODUCTS,
  //   });
  // };

  return (
    <ProductContext.Provider
      value={{
        products: state.products,
        current: state.current,
        filtered: state.filtered,
        error: state.error,
        getProducts,
        addProduct,
        deleteProduct,
        updateProduct,
        filterProducts,
        clearFilter,
        setCurrent,
        clearCurrent,
        // clearProducts,
      }}
    >
      {props.children}{" "}
    </ProductContext.Provider>
  );
};

export default ProductState;
